import { useSelector } from 'react-redux';

import { useAppDispatch } from 'hooks';
import { selectAcccountCurrentCityPoint } from 'redux/account/selectors';
import { setGeoLocationStatus } from 'redux/geolocation/actions';
import { selectGeoLocation } from 'redux/geolocation/selectors';
import { LocationPoint } from 'redux/geolocation/reducer';
import { logError } from 'utils/errorHandling';

const useGeoLocation = () => {
    const accountCurrentCityPoint = useSelector(selectAcccountCurrentCityPoint);
    const geoLocation = useSelector(selectGeoLocation);

    const dispatch = useAppDispatch();

    const getCurrentPosition = (): Promise<GeolocationPosition> => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(dispatch(setGeoLocationStatus({ allowed: false })));
            } else {
                navigator.geolocation.getCurrentPosition(resolve, reject);
            }
        });
    };

    const getUserGeoPoint = async (): Promise<LocationPoint | undefined> => {
        if (geoLocation.allowed && geoLocation.location) {
            return geoLocation.location;
        }

        if (geoLocation.allowed === false) {
            return accountCurrentCityPoint;
        }

        if (navigator.geolocation) {
            try {
                const position = await getCurrentPosition();
                const location = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                };

                dispatch(
                    setGeoLocationStatus({
                        allowed: true,
                        location,
                    }),
                );

                return location;
            } catch (err) {
                logError('Error while getting geolocation: ', err);
                dispatch(setGeoLocationStatus({ allowed: false }));

                return accountCurrentCityPoint;
            }
        }
    };

    return {
        getUserGeoPoint,
        getUserGeoLocation: async () => {
            const location = await getUserGeoPoint();

            if (location) {
                return `${location.latitude},${location.longitude}`;
            }
        },
    };
};

export default useGeoLocation;
